// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pop-buttons
{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5%;
}`, "",{"version":3,"sources":["webpack://./src/app/new-media/new-media-manager/media-upload-dialog/media-upload-dialog.component.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":[".pop-buttons\r\n{\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-top: 5%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
